import { Table, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useListNeedsQuery } from "../../../../autogen/bff-api";
import { useLoggedInWithOrgContextState } from "../../../../common/auth/useLoggedInWithOrgContextState";
import { useDisplayDate } from "../../../../common/formatting/useDisplayDate";
import { urls } from "../../../../urls";
import { HomePanel } from "./HomePanel";

export const MyNeedsPanel = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const displayDate = useDisplayDate();
  const authState = useLoggedInWithOrgContextState();
  const { data, isLoading, isError } = useListNeedsQuery({});
  // No server-side "mine" filter for needs, so scope to the current user client-side by
  // createdBy (needs have no responsible buyer; cf. eventsResponsibleFor on the event panels).
  const needs = (data?.needs ?? []).filter((n) => n.createdBy?.id === authState.me.id).slice(0, 6);

  return (
    <HomePanel titleKey="My needs" seeAllTo={urls.v2.needs.mine} isLoading={isLoading} isError={isError} isEmpty={needs.length === 0} emptyKey="No needs yet">
      <Table variant="simple" size="sm">
        <Thead><Tr><Th>{t("Title")}</Th><Th>{t("Created")}</Th></Tr></Thead>
        <Tbody>
          {needs.map((n) => (
            <Tr key={n.id} cursor="pointer" _hover={{ bg: "smPrimarySofter" }} onClick={() => navigate(urls.v2.needs.view.go(n.id))}>
              <Td fontWeight="medium" color="smText">{n.title || t("Untitled")}</Td>
              <Td color="smMuted" fontSize="sm">{displayDate(n.createdAt)}</Td>
            </Tr>
          ))}
        </Tbody>
      </Table>
    </HomePanel>
  );
};
